<epg-toolbar />

@if (applicationName) {
  <div class="app-menu">
    @for (menu of applicationMenuBar; track menu) {
      <a [routerLink]="menu.path" [routerLinkActive]="'active'">
        {{ menu.alias || menu.label }}
      </a>
    }
  </div>
}
<div class="page-wrapper">
  <div class="page-section">
    @if (showBackPageLink()) {
      <a (click)="navigateBack()" class="previous-page-link">
        <i class="fas fa-arrow-left"></i>
        {{ navigateToPreviousLabel ?? 'Back to previous page' }}
      </a>
    }
    <router-outlet />
  </div>

  <!-- TODO: Revisit for future changes when the navigation bar is completed -->
  <!-- <div class="page-container">
          @if (showBackPageLink) {
                <div class="back-action">
                    <a [routerLink]="navigateBack()">
                        <i class="fas fa-arrow-left"></i> {{ backLinkToParentTitle || pageLinkTitle ??   'Back to previous page'}}
                    </a>
                </div>
            }  -->
  <!-- <div class="page-content">
            <router-outlet />
        </div> -->
  <!-- </div> -->

  <!-- TODO: animated page -->

  <!-- <div class="page-section"  [@routeAnimation]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"/>
    </div> -->
</div>
